import { RootState } from 'store/store';

export const selectActiveTemplate = (state: RootState) => state.manager.activeTemplate;
export const selectIsLoading = (state: RootState) => state.manager.isLoading;
export const selectIsLoaded = (state: RootState) => state.manager.isLoaded;
export const selectIsSaving = (state: RootState) => state.manager.isSaving;
export const selectError = (state: RootState) => state.manager.error;
